export type AliasOptions = {
  /** Full base email like "you@gmail.com" */
  baseEmail: string
  /** How many aliases to produce */
  count: number
  /** First numeric suffix (defaults to 1) */
  startAt?: number
  /** Width of the numeric suffix (zero-padded). Default 4 → 0001, 0002… */
  pad?: number
  /** Custom suffix between local-part and `+` (defaults to numeric only) */
  prefix?: string
}

export type AliasRow = {
  index: number
  email: string
  /** The `+tag` portion alone, useful as a unique handle component */
  tag: string
}

export function generateAliases(opts: AliasOptions): AliasRow[] {
  const { baseEmail, count } = opts
  const start = opts.startAt ?? 1
  const pad = opts.pad ?? 4
  const prefix = opts.prefix ?? ''
  const at = baseEmail.indexOf('@')
  if (at <= 0 || at === baseEmail.length - 1) {
    throw new Error('baseEmail must be in the form "you@example.com"')
  }
  let local = baseEmail.slice(0, at)
  const domain = baseEmail.slice(at + 1)
  // Strip any pre-existing +tag from the local-part so we don't end up with
  // `you+old+0001@…`
  const plus = local.indexOf('+')
  if (plus >= 0) local = local.slice(0, plus)

  const out: AliasRow[] = []
  for (let i = 0; i < count; i++) {
    const n = start + i
    const tag = `${prefix}${String(n).padStart(pad, '0')}`
    out.push({ index: n, email: `${local}+${tag}@${domain}`, tag })
  }
  return out
}
